import { Injectable, QueryList, ViewChild, ViewChildren } from '@angular/core';
import * as Constants from '../models/Constants';
import { BehaviorSubject, delay, Observable, Subject, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DialogComponent } from '../components/common/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ItemModel } from '../models/ItemModel';
import { Tab } from '../models/tab.model';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { CommonDialogData } from '../models/CommonDialogData';
import { awsConfig, CCTConfigs } from '../models/CCTConfigs.model';
import {
  FormBuilder,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Global } from '../global/globalApi';
import { accountDtModal } from '../models/CustomerAccountSearch';
import { TbaRegistrationDTO } from '../models/TbaRegistrationDTO';
import { AaaSModel, AngularLogObject, sAuthModel } from '../models/customer.model';
import { AwsSqsService } from './aws-sqs.service';
import { MatSelect } from '@angular/material/select';
import moment from 'moment';
import CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root',
})
export class RootScopeService {
  @ViewChild(MatTabGroup, { read: MatTabGroup })
  public tabGroup!: MatTabGroup;
  @ViewChildren(MatTab, { read: MatTab })
  public tabNodes!: QueryList<MatTab>;
  dialogMsg: any;
  loadUI: boolean = false;
  hideBtn: boolean = false;
  timerStarted: boolean = false;
  userLoggedIn :boolean = false;
  loginAccountUnauthorizedError: boolean = false;
  loginAccountBlockedError: boolean = false;
  loginAccountUnexpectedError: boolean = false;
  ALISRegistrationCardError: boolean = false;
  ALISRegistrationCardMsgAfterSessionPopUp: boolean = false;
  ALISRegistrationCardSuccess: boolean = false;
  selectedALISRegion: any = '';
  ALISRegistrationSuccessChangeOrg: boolean = false;
  _ALISSelectedRegionObj = new BehaviorSubject<any>(null);
  //Below properties are defined for Training/Testing/EMEA 
  ALISTrainingTestingInfoMsg: boolean = false;
  ALISChangeOrgInfoMsg: boolean = false;
  ALISTrainingTestingSuccessMsg: boolean = false;
  GENESYS_CLOUD_CLIENT_ID: string = '';
  public holdLiveDetails: Tab[] = new Array<Tab>();
  public telephonyEventDebugDTO: AngularLogObject = new AngularLogObject();
  public liveInteractionLogs = new Map();
  public awsSQSService = new AwsSqsService(this);
  public genesysNotificationCall = new BehaviorSubject<any>(Object.assign({}));
  public outboundCallDialingSub: Subscription = new Subscription();
  public outboundCallConnectedSub: Subscription = new Subscription();
  public agentQueues: Array<any> = new Array<any>();
  public agenIneractionData: any = {};
  public dashboardClientId: any = '';
  public customerSearchClientId: any = '';
  public dashboardClientName: any = '';
  public customerSearchClientName: any = '';
  public sortedClientList: Array<any> = new Array<any>();
  public mulLanData: Array<any> = new Array<any>();
  public clientPropDataMap= new Map();
  public researchAttributeMap = new Map();
  public deliveryMethodsMap = new Map();
  public clientInfoCard = {
    clientInfoVSClientIdMap: new Map(),
    defaultClientInfoServiceVSClientIdMap: new Map(),
    clientInfoCardDefaultServiceIndex: 0,
  };
  public emailList: any = '';
  public postalAddress: any = '';
  public deliveryOption: any = '';
  public pinRestErrorMsg: any = '';  
  public planTypesForHealthCard: any = [];
  public kcPortalList: any = [];
  public healthCardApprovedExceptionList: any = [];
  public awldsAgentIHChannelLists: any = [];
  public awldsCustomerIHChannelLists: any = [];
  public ihDomainLists: any = [];


  public interactionHistoryConfig = {
    MAX_DAYS_FOR_LEGACYDATA: Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_DAYS_FOR_LEGACYDATA_VALUE,
    MAX_IH_RECORDS_LEGACYDATA: Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_IH_RECORDS_LEGACYDATA_VALUE
  }

  logOutMsg: boolean = false;
  appConfigObj: any;
  userData: any;
  userName: any = 'test';
  emailId: any;
  callType: any = 'NA';
  customDialogContent: any;
  buttonType: any;
  customerTypeData: any[] = [];
  IHChannelList: any[] = [];
  domainList: any[] = [];
  thirdPartyList: any[] = [];
  unknownCallerTypeList: any[] = [];
  unknownCallerTypeAPIFailure: boolean = false;
  tempAddressEnabled: boolean = false;
  domainListAPIFailure: boolean = false;
  IHListCount: number = 0;
  primaryLanguage: any[] = [];
  preferredLocale: any[] = [];
  //isFilterApplied: boolean = false;
  showInboundValidateMsg: any = new BehaviorSubject<boolean>(false);
  showChatValidateMsg: any = new BehaviorSubject<boolean>(false);
  //transfer
  istransferred: any;
  isConference: boolean = false;
  customerTypeDrpDwn: any = 'ACH';
  apiUrl;
  peaAuthUserDetails = new Subject<any>();
  logSubject = new Subject<{message:any;fileName:string, Type?:string}>();
  /**Below Variables are used for Network Indicator in header component */
  isNetworkOnline: boolean = false;
  speed = new Subject<number>();
  speedThreshold: number = 0;
  timeThreshold = new Subject<number>();
  showRepeatAlert: boolean = true;
  repeatAlertMsg: string = "test";
  /**Below Variables are used for TBA connectivity Indicator in header component */
  tbaIndicatorClass = new BehaviorSubject<string>(
    Constants.TBA_INDICATOR_COLOR.GRAY
  );
  utilityStatusClass:any='';
  tbaConnectivitySetInterval: any;
  tbaConnectivityThreshold: number = 60 * 1000;
  UtiltyConnectivityThreshold: number = 60 * 1000;
  alisConInterval: number = 30000;
  liveInteractionInterval: any
  clientSystemIds = new Array();
  loaderTypeCard = Constants.LOADER_TYPE.CARD;
  isClientMapped: boolean = false;
  showLoaderMsgThreshold: number = 5;
  dataSource: any = new MatTableDataSource();
  // setting live call status globally
  public isLiveCall: boolean = false;
  public isLiveChat: boolean = false;
  public liveChatCTS: Array<any> = new Array<any>();
  public selectedClient: any;
  // Below variables are used for ALIS Registration org details
  public invalidENV: boolean = false;
  public invalidENVBanner: boolean = false;
  public alisOrganizations: any = [];
  public organizationName: string = '';
  public datePipe = new DatePipe('en-US');
  sessionId: any;
  /**Below variables are used for Progress Bar */
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();
  public alisRegistrationLoader = false;
  public custAccInteractionLoader = false;
  public custSearchLoader = false;
  public dashboardLeftNavLoader = false;
  public attributeClientConfigMap = new Map();
  public moduleRefreshCounterMap: Map<string, number> = new Map();
  public log_config: any = {
    credentials: new awsConfig(),
    region: "",
  };
  public IH_config: any = {
    credentials: new awsConfig(),
    region: "us-east-1",
  };
  /**Below variables are used to show Progress Bar along with loading message
   * if data doesn't load with in Threshold limit*/
  public showAlisRegistrationLoaderMsg: boolean = false;
  public alisRegistrationLoaderTimeoutId: any;
  public showCustAccInteractionLoaderMsg = false;
  public custAccInteractionLoaderTimeoutId: any;
  public showCustSearchLoaderMsg: boolean = false;
  public custSearchLoaderTimeoutId: any;
  public dashboardLeftNavLoaderMsg: boolean = false;
  public dashboardLeftNavTimeoutId: any; dashboardLeftNavError: boolean = false;
  public exceptionTypeandSubTypeAPIConfigMissErrorMsg: string = '';
  // Map of UdpId and list of Links Accessed
  public linkTrackingMap = new Map();
  public smartSearchData: any = {};
  public endRegistrationMsg: string = '';
  public roleTypeListForPlatFormInternalIdTable:any;

  //Below variables are used for Interaction History filter pop-up loader of legacy data API
  public custAccInteractionFilterLoaderTimeoutId: any;
  public custAccInteractionFilterLoaderVariables = {
    loader: false,
    loaderMsg: false,
  }


  /**Below variables are used for AuthGuard for Authentication of the Application */
  public _isAuthenticated = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this._isAuthenticated.asObservable();
  public sessionExpiry: boolean = false;
  /**Below variable is used for LogoutGuard */
  public _isLogout = new BehaviorSubject<boolean>(false);
  /**Below variables are used for My Dashboard Left Nav Bar */
  dashboardNavBarData: any = [];
  pinRestTbaGuipostDetails: any = [];
  selectedMenu: string = 'DASHBOARD-BUSINESS-ENGINES';
  selectedSubMenu: string = '';

  /**Below variables are used for My Dashboard MyTodo Card*/
  dashboardMyTodoData: any;
  dbCaseManagementLoader: boolean = false;
  showDbMyTodoLoaderMsg: boolean = false;
  dbMyTodoloaderTimeoutId: any;
  isDbCaseManagementErrorEnabled: boolean = false;
  hasNoDbCaseManagementData: boolean = false;
  isCustAccCaseManagementErrorEnabled: boolean = false;
  alertTypesDataMap: any = {};
  dataBaseSelecterMap: any = {};
  authConfigDataMap: any = {};  authConfigValue: any;
  authConfigUserDataMap: any = {}; accountSAuthConfig:sAuthModel=new sAuthModel();
  AaaSConfigUserDataMap: any = {}; accountAaaSConfig: AaaSModel = new AaaSModel();
  wrapupTopicDataMap: any = {};
  filterDomainListData: any = [];
  isAlertAdded: boolean = false;
  newAlertId: string = '';
  launchAppFromManualLogin: boolean = false;
  launchAppBySSO: boolean = false;
  isDuplicateSession: any;
  
  firstName: string='';
  lastName: string='';
  name: any; browserSessionStartTimestamp: string = '';
  isAuthenticate: boolean = false;
  isActiveTabRefreshed: boolean = false;
  isSSODuplicate: boolean = false;

  oldSessionId: string = '';
  newSessionId: string = '';
  customDialogData: any = {};
  customerSearchForm: FormGroup = new FormGroup({});
  dashboardForm: FormGroup = new FormGroup({
    clientId: new FormControl(''),
    clientNameDash: new FormControl('')
  });
  customerTypeForm: FormGroup = new FormGroup({ customerType: new FormControl('') });
  approvedTypeExceptionForm: FormGroup = new FormGroup({ type: new FormControl(''), subType: new FormControl('') });


  customerFormValues: any;
  totalCount: any;
  lanId: any;
  /* Below varible contains the preference region value of ALIS registration */
  preferenceRegion: any = '';
  callChatReceived: boolean = false;
  isOutBoundCall: boolean = false;
  public genesysCallObj: any;
  callChatEnds = new BehaviorSubject<boolean>(false);
  multipleChatCaseForClearingState: boolean = false;
  isCallBackCall: boolean = false;
  public conversationId: any = 'NA';
  static apiURl: any;
  public altOutboundCall: boolean = false;
  public isLogEnabledUser: string =  Constants.ERROR;
  public isLogEnabledUserAlisIntr: string = Constants.USAGE;
  TBAGUIRegistrationUnauthorized: boolean = false;
  TBAGUIRegistrationnAuthorized: boolean = false;
  TBAGUIConnected: boolean = false;
  TBAGUIHealthCheckError: boolean = false;
  TBAGUIRegistrationUnexpectedError: boolean = false;
  TBAGUIRegistrationPassExpire: boolean = false;
  TBAGUIAccountLockedError: boolean = false;
  TBAGUIAuthenticated: boolean = false;
  isDuplicateCustSearchTabOpened: boolean = false;
  callBackCallDisconnected: boolean = false;
  displayRedIcon: boolean = false;
  callFromSL1Tab: any;
  tbaGuiRegisterFormObj = new TbaRegistrationDTO();
  tbawindow = new Map();
  restoreSession: boolean = false;
  public tbaPayloadMap = new Map();
  public customerTypeAPIFailure: boolean = false;
  public eGainContainerList = new Map();
  public externalTabList = new Map();
  public newTabId = new Map();
  public openFilterDialog: boolean = false;
  public openCreateAlertDialog: boolean = false;
  public openAdminFilterDialog: boolean = false;
  public openInteractionFilter: boolean = false;
  public openViewParticipant: boolean = false;
  public showEditCommentsModal: boolean = false;  
  public timemoutPopUpInteraval: any;
  public clonedActiveCustTab: any;
  public Prod_lifeCycle: boolean = false;
  public accountModalPopup = new Map();
  /**Below Variable used for Aprroved Exception Component */
  exceptionsList: any = [];
  subExceptionsList: any = [];

  public isALisRegistered: boolean = false;
  public alisRegions: any = [];
  public prefrenceRegionObj: any;

  /**Below map holds the documents info for a participant */
  public customerTbaDocumentsMap = new Map();
  public authorized_roletype: any;
  public authorizedRoleType: any;
  public isScreenpopAttributeEnabled: boolean = true;
  VALChannel: any = ['ALIS ALV'];
  platformTypeList :any = [];

  public pinResetErrorList : any = [];
  public tbaguiLifeCycleList : any = [];
  public tbaguiLifeCycleAPIFailure : boolean = false;
  public getValidFieldValuesApiFailure : boolean = false;

  public interactionTypeList: any[] = [];
  public interactionModesList: any[] = [];
  public interactionModeSubTypeList: any[] = [];
  public refreshAlertList: boolean = false;

  /**Below method return the Observable of response Boolean for AuthGuard
   * by checking on the validation of
   * the user Succesfully login or already have active User Session
   */
  /* istanbul ignore next */
  isAuthenticated(): Observable<boolean> {
    let jId = localStorage.getItem('jId');
    if (jId != undefined || jId != null) {
      this._isAuthenticated.next(true);
      this.isAuthenticate = true;
    }
    return this.isAuthenticated$;
  }
  /**Below variables are used for alerts */
  isGENSYSErrorToHide: boolean = true;
  isGensysUDPErrorToHide: boolean = true;
  isWarningToHide: boolean = true;
  isErrorToHide: boolean = true;
  isInfoToHide: boolean = true;
  isSuccessToHide: boolean = true;
  alertMsg: any;
  display: boolean = true;
  warningMsg: any;
  errorMsg: any;
  infoMsg: any;
  successMsg: any;
  customerLink: any = 0;
  activeLink = Constants.CCR_Dashboard;
  //public CCTConfigs = 1;
  CCTConfigs: CCTConfigs = {
    TIME_THRESHOLD: 60,
    INTERACTION_REFRESH_LINK_LOGS_TIME:60,
    TIME_THRESHOLD_SUBSEQUENT: 60,
    MAXMIUM_ACCOUNTS: 5,
    ACTIVE_SESSION_EVALUATE_INTERVAL: 120000,
    APP_IDLE_TIME: Constants.idle_Time,
    APP_TIMEOUT: Constants.appTimeout,
    APP_SESSION_TIMEOUT: Constants.sessionOut,
    GENSYS_IDLE_TIME: Constants.GENSYS_IDLE_TIME,
    OUTBOUND_POPUP_TIME: Constants.OUTBOUND_POPUP_TIME
  };
  indicatorClass: string = "gray";
  public wrappedUpComplete = new BehaviorSubject<boolean>(false);

  items: ItemModel[] = [
    { name: 'My Dashboard', selected: true, id: 'dashboard' },
    { name: 'Customer Accounts', selected: false, id: 'search' },
    // Disable the Simulator tab. 
    //{ name: 'Simulation Manager', selected: false, id: 'simulation'}
    // Disable the Administration tab.
     //{ name: 'Administration', selected: false, id: 'administration'}
  ];
  customerTabs: Tab[] = [Object.assign(new Tab(), {
    id: 0,
    title: 'Customer Search',
    tabData: null,
    activeCall: false,
    activeChat: false,
    active: true,
    iconClass: 'green',
    additionalAccount: false,
    closeIcon: false,
    customerSessionId: '0'
  })
    // {
    //   id: 0,
    //   title: 'Customer Search',
    //   tabData: null,
    //   activeCall: false,
    //   activeChat: false,
    //   active: true,
    //   iconClass: 'green',
    //   additionalAccount: false,
    //   closeIcon: false,
    //   customerSessionId: '0',
    //   idle: false,
    //   outboundCallInitiate: false,
    //   isWrapupDone: false,
    //   authenticateStatus: Constants.Not_Applicable,
    //   CS_SECURITY_LEVEL: '',
    //   isAdditionalAccOpen: '',
    //   parentId: '',
    //   additionalAccountId: '',
    //   domainIndex: null,
    //   subDomainIndex: null,
    //   domainsTopics: null,
    //   clientId: '',
    //   customerType: 'ACH',
    //   startTime: new Date(),
    //   conversationId: '',
    //   endTime: new Date(),
    //   channel: '',
    //   reasonForAdditional: { firstReason: '', subReason: '' },
    //   isChatTransferred: false,
    //   lastInteractionStatus: '',
    //   customerParticipantId: '',
    //   isCustAccCaseManagementErrorEnabled: false,
    //   roleType: 'Employee',
    //   showContent: true,
    //   defaultRole: 'Employee',
    //   startSL: '',
    //   endSL: '',
    //   showRepeatAlert: false,
    //   repeatAlertMsg: '',
    //   approvedExceptionsTypes: null,
    //   showRepeatAlertBriefView: false,
    //   showRepeatAlertListView: false,
    //   callConnectedTime: '',
    //   lastStartTime: '',
    //   wrapUpData: new WrapUpData,
    //   approvedExceptionCredentialData: null
    // }

  ];
  public activeCustTab: Tab = new Tab();
  public roletypeList: any[] = [];
  public customerAccountDt: accountDtModal[] = [];
  isModelopen: boolean = false; outBoundPopUp: any;
  public unknownTab: any;
  public liveCallDetails = new BehaviorSubject<any>(Object.assign({}));
  public liveChatDetails = new BehaviorSubject<any>(
    Object.assign({ attributes: { CS_CLIENT_ID: '0' } })
  );
  public ssoError: string = '';
  public openedWindows: Array<any> = [];
  //approved and authentication common details \
  is_SecuredMap = new Map();
  // public conversationId: string = '';
  public timespan = '';
  public timeOutDetails = new BehaviorSubject({ "watch": false, 'stop': false });;
  browserSubscription!: Subscription;
  public clearInterval: boolean = false;
  public interactionsMap = new Map();
  public updateElasticData = new Subject<any>();
  public authMethodConfig = new Map();
  public globalIconId = '';
  public simulationData: any = {};
  public chatAttributes: any = null;
  public callAttributes: any = null;
  public screenPopAttributes: any = null;
  public callClientConfig = new Map();
  public chatClientConfig = new Map();
  public screenPopConfig = new Map();
  public CSProTransferConfig = new Map();//CCR3-7385
  public callerTypeAlert: boolean = false;
  public callertTypeValue = { oldTypeValue: "", newTypeValue: "" };
  public dropDown!: MatSelect;
  public patchGENAttribute = new Subject<any>();
  public chatConversations = new Map();
  public isAgentFilterApplied: boolean = false;
  public isCarePortalProd: boolean = false;
  public GenesysPureCloud: any;
  public appTimeoutSuccess: boolean = false;

 /**Agent skills  related variables ***/
  public isUDPIdSkillForCustomerSearch: boolean = false;
  public isSkillPresentForWrapUpComment :boolean = false;
  public batchAlertData = {
    isBatchAlertAccess: false,
    isBatchAlertToggleOn: false,
    isBatchAlertModeActive: false,
 };
  

  public alisHeartBeatTimeStamp : Date | undefined;

  public cimData_config: any;
  public duelDesk_indicator: any;
  public authAttempts = new Map();//CCR3-6188
  public PEAchannels=["ALS PEA"];
  fileName: string = 'rootScopeService';
  simulationTypes: any[] = [];
  authenticationMethod:[] = [];
  unauthorizedConversations: any[] = [];
  simulation_outbound_time=5000;
  LOB_methods: any[] = [];
  Simulation_LOB_map: Map<string, {
    authModels: string;
    lobTypes: string[];
  }[]> = new Map();
  public simulationRecords: any[] = [];
  public showPinReminderConfirmationOverlay: boolean = false;
  public pinReminderSuccessMsg: string = '';
  public pinReminderErrorMsg: string = '';
  public pinReminderAddress = new Map<string, string>();
  public myFRSLink: string = '';
  public pinReminderSuccessPPT=new Map<string, string>();
  
  constructor(
    public dialog: MatDialog,
    public router: Router,
    private fb: FormBuilder,
    public http: HttpClient,) {
    this.retainCustomerData();

  }

  /**
   * @param obj
   * Below method for check the object if object is blank return false else return true
   */
  checkBlankObj(obj) {
    return obj && Object.keys(obj).length != 0;
  }

  getSecurityModel(clientId){
    let clientPropData = this.clientPropDataMap?.get(clientId);
    const securityObj = clientPropData?.find(item => item?.propertyName?.toLowerCase() === 'security-config');
    if(securityObj){
      let obj = JSON.parse(securityObj?.propertyValue?.toLowerCase());
      return obj?.securitymodel;
    }
    return null;
  }

  /**
  * getNoPinClientModel() - Checks if the selected client has a "No Pin" model.
  * @param clientId - The ID of the selected client.
  * @returns {boolean} - Returns true if the client model is "No Pin", otherwise false.
  */
  getNoPinClientModel(clientId: string): boolean {
    let clientPropData = this.clientPropDataMap?.get(clientId);
    const securityObj = clientPropData?.find(item => item?.propertyName?.toLowerCase() === 'security-config');
    if (securityObj) {
      let obj = JSON?.parse(securityObj?.propertyValue);
      return obj?.ClientModel?.toLowerCase() === Constants.NO_PIN;
    }
    return false;
  }


  /**
   * Below Method check Active call and Active chats */
  activeChatOrCall() {
    return this.customerTabs.filter(
      (x) =>
        (x.activeCall && !x.additionalAccount) ||
        (x.activeChat && !x.additionalAccount)
    ).length;
  }
  /* Check Security for validation cls icon */
  validationClsIcon() {
    return this.checkCallOrChat() && this.activeChatOrCall() == 0;
  }
  /*Below Method for check any live call or chat is going on based on set client value in client drop down  */
  checkCallOrChat() {
    return (this.isLiveCall || this.isLiveChat);
  }

  // setting genesys login status globally
  public isGenesysLoggedIn: boolean = false;
  setIsGensysLoggedIn(genesysLoggedInStatus) {
    if (genesysLoggedInStatus) {
      this.isGenesysLoggedIn = genesysLoggedInStatus;
    } else {
      this.isGenesysLoggedIn = false;
    }
  }
  /**
   * @param type
   * Below method is used to display
   * various types of alerts
   * Assumptions: Only 1 alert will be displayed at once
   */

  enableAlerts(type, msg) {
    if (type == Constants.WARNING) {
      this.isWarningToHide = false;
      this.warningMsg = msg;
    } else if (type == Constants.ERROR) {
      this.isErrorToHide = false;
      this.errorMsg = msg;
    } else if (type == Constants.INFO) {
      this.isInfoToHide = false;
      this.infoMsg = msg;
    } else if (type == Constants.SUCCESS) {
      this.isSuccessToHide = false;
      this.successMsg = msg;
    }
  }
  //get live call details
  public getLiveCallDetails() {
    return this.liveCallDetails.asObservable();
  }

  //get live chat details
  public getLiveChatDetails() {
    return this.liveChatDetails.asObservable();
  }

  /*Date Formatter to set reuired formate date*/
  dateFormatter(date, formate: string) {
    try {
      return this.datePipe.transform(date, formate);
    } catch (error) {
      console.error('Error formatting date:', error);
      return date;
    }
  }

  /**clearing all cache ,called when logoff is done  *****/
  clearCache() {
    sessionStorage.clear();
    localStorage.clear();
  }

  /**
   * @param url
   * Below method is common method to open new window
   * to be used throughout the application
   */
  openNewWindow(url) {
    let val = 0;
    var params = [
      'height=' + screen.availHeight,
      'width=' + screen.availWidth,
      'top=' + val,
      'left=' + val,
      'fullscreen=yes',
    ].join(',');

    window.open(url, '_blank', params);
  }

  openNewTab(url: string) {
    //this.openChild(url);//browse/506900000087959/Security-Guides
    window.open(url, '_blank');
  }


  getCommonHeaders(apiVersion: any) {
    return new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Basic MmxeX3d6cUNXLTo0NXlPJE9UbFU=')
      .append(
        'awcpusertoken',
        this.sessionId
          ? this.sessionId
          : this.getValueFromLocalDb('userSession', '12345678')
      )
      .set('Accept', 'application/json')
      .append('version', apiVersion)
  }

  getCustAccHeaders(apiVersion: any, customerSessionId: any) {
    return new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Basic MmxeX3d6cUNXLTo0NXlPJE9UbFU=')
      .append('awcpcusttoken', customerSessionId)
      .append(
        'awcpusertoken',
        this.sessionId
          ? this.sessionId
          : this.getValueFromLocalDb('userSession', '12345678')
      )
      .set('Accept', 'application/json')
      .append('version', apiVersion)
  }


  /*Method to show the Progress Bar*/
  showLoader() {
    this._loading.next(true);
  }

  /*Method to hide the Progress Bar*/
  hideLoader() {
    this._loading.next(false);
  }

  //hide all error
  hideError() {
    if (!this.errorMsg?.includes('GEN')) {
      this.isErrorToHide = true;
    }
    this.isWarningToHide = true;

    this.isSuccessToHide = true;
  }
  /***
   * Below method is used to
   * trigger opening and closing of the dialog .
   */
  /* istanbul ignore next */
  // Common Dialog method here
  openDialog(data: CommonDialogData): Observable<boolean> {
    return this.dialog
      .open(DialogComponent, {
        data,
        panelClass: ['custom-dialog', data?.additionalClass],
        backdropClass: 'custom-overlay',
        disableClose: true,
        id: data?.id || '',
      })
      .afterClosed();


  }

  setTabStatus(val) {
    this.loadUI = val;
    if (val) {
      window.name = Constants.ACTIVE_TAB;
    } else {
      window.name = Constants.NO_ACTIVE_TAB;
    }
  }

  setSessionIdInLocalStorage(val) {
    this.sessionId = val;
    console.log('this.sessionI', this.sessionId);
    localStorage.setItem('userSession', val);
    sessionStorage.setItem('userSession', val);
  }

  scrollToTop() {
    window.scroll(0, 0);
  }

  scrollToBottom() {
    setTimeout(() => {
      window.scroll(0, document.body.scrollHeight);
    }, 10);
  }

  // /**
  //  *@ Vamsi.Pamidala
  //  * @param customerTabs  restore Customer accounttabs in alis resigter 
  //  * @returns land in same page/routing path
  //  */

  retainCustomerData() {

    if (sessionStorage.getItem('customerTabs')) {
      const refreshData = this.getValueFromSessiondb('customerTabs', {
        customerSearchData: this.customerSearchForm,
        resultData: this.dataSource,
        customerLink: this.customerLink,



      });

      this.customerLink = refreshData.customerLink;
      this.dataSource = new MatTableDataSource(refreshData.resultData);
      this.customerFormValues = refreshData.customerSearchData;
      this.totalCount = refreshData.resultData.length;

      this.dashboardForm.get('clientId')?.setValue(refreshData.clientId);
      this.dashboardForm.get('clientNameDash')?.setValue(refreshData.clientNameDash);
      this.dashboardClientName = refreshData.dashboardSelectedClient;
      this.dashboardClientId = this.getClientId(refreshData.dashboardSelectedClient);

      sessionStorage.removeItem("customerTabs");
    }
  }
  /**
   * Below method return each config object from array of applicationConfiguration
   * as per field Name
   */

  getObjFromConfigObj(fieldName) {
    return _.find(this.appConfigObj, function (each) {
      return each.fieldName == fieldName;
    });
  }

  getValueFromSessiondb(value, dummy) {
    const data = sessionStorage.getItem(value);
    return data ? JSON.parse(data) : dummy;
  }

  getValueFromLocalDb(value, dummy) {
    const data = localStorage.getItem(value);
    this.sessionId = data;
    return data ? data : dummy;
  }

  /*common method for find */
  getObjFromArray(list, id, value) {
    return list.find((x) => x[id] == value);
  }

  tabTitleChars: number = 11;
  activeTabTitleChars: number = 21;
  rowPerPage: number = 10
  onResize() {
    if (window.innerWidth >= 1920) {
      this.tabTitleChars = 11;
      this.activeTabTitleChars = 21;
      this.rowPerPage = 20;
    } else if (window.innerWidth < 1920 && window.innerWidth >= 1440) {
      this.tabTitleChars = 7;
      this.activeTabTitleChars = 21;
      this.rowPerPage = 8;
    } else if (window.innerWidth < 1440 && window.innerWidth >= 1024) {
      this.tabTitleChars = 4;
      this.activeTabTitleChars = 13;
      this.rowPerPage = 5;
    } else {
      this.tabTitleChars = 11;
      this.rowPerPage = 10;
    }
  }

  setUserAndEmailInStorage() {
    localStorage.setItem('userSession', this.sessionId);
    sessionStorage.setItem('userSession', this.sessionId);
    localStorage.setItem('emailId', this.emailId);
    const encryptedFirstName = CryptoJS.AES.encrypt(this.firstName, 'secretKey').toString();
    sessionStorage.setItem('firstIdentity', encryptedFirstName);
    const encryptedLastName = CryptoJS.AES.encrypt(this.lastName, 'secretKey').toString();
    sessionStorage.setItem('lastIdentity', encryptedLastName);
    sessionStorage.setItem('browserSessionStartTimestamp', this.browserSessionStartTimestamp);
  }

  createNameForUserProfile(fIdentity, lIdentity, lanId, browserSessionStartTimestamp,emailId?) {
    let firstIdentity=fIdentity;
    let lastIdentity=lIdentity;
    this.firstName = fIdentity;
    this.lastName = lIdentity;
    this.lanId = lanId;
    this.emailId = emailId;
    this.browserSessionStartTimestamp = browserSessionStartTimestamp;
    if (fIdentity && lIdentity) {
      this.name =
      fIdentity.charAt(0).toUpperCase() + lIdentity.charAt(0).toUpperCase();
      sessionStorage.setItem('firstIdentity', firstIdentity);
      sessionStorage.setItem('lastIdentity', lastIdentity);
      localStorage.setItem('emailId',this.emailId);
      sessionStorage.setItem('emailId',this.emailId);
    }
    return true;
  }

  getNetworkConfigValues() {

    let timeThresholdObj = this.getObjFromConfigObj(
      Constants.NETWORK_SPEED_TEST.timeThreshold
    );
    let speedThresholdObj = this.getObjFromConfigObj(
      Constants.NETWORK_SPEED_TEST.speedThreshold
    );
    let apiThresholdObj = this.getObjFromConfigObj(
      Constants.NETWORK_SPEED_TEST.apiThresholdLimit
    );
    let alisConIntervalObj = this.getObjFromConfigObj(
      Constants.NETWORK_SPEED_TEST.alisConInterval
    );
    this.speedThreshold = speedThresholdObj?.fieldValue ? speedThresholdObj?.fieldValue : Constants.NETWORK_SPEED_TEST.speedThresholdDefaultValue;
    this.timeThreshold.next(timeThresholdObj?.fieldValue ? timeThresholdObj?.fieldValue : Constants.NETWORK_SPEED_TEST.timeThresholdDefaultValue);
    this.showLoaderMsgThreshold = apiThresholdObj?.fieldValue ? apiThresholdObj?.fieldValue : Constants.NETWORK_SPEED_TEST.apiThresholdLimitDefaultValue;
    this.tbaConnectivityThreshold = timeThresholdObj?.fieldValue ? timeThresholdObj?.fieldValue : Constants.NETWORK_SPEED_TEST.timeThresholdDefaultValue;
    this.alisConInterval = alisConIntervalObj?.fieldValue ? alisConIntervalObj?.fieldValue : Constants.NETWORK_SPEED_TEST.alisConIntervalDefaultValue;
  }

  /**
   * @author vamsikrishna
   * Below method will return which attribute to look in
   * ALIS Object based on client id config
   * 
   */
  conversationConfig(clientId) {

    let chatAttributesConfig = this.chatClientConfig.get(clientId);
    let callAttributesConfig = this.callClientConfig.get(clientId);
    let callBaseConfig = this.callClientConfig.get("BASE");
    let chatBaseConfig = this.chatClientConfig.get("BASE");

    this.chatAttributes = chatAttributesConfig ? chatAttributesConfig : chatBaseConfig;
    this.callAttributes = callAttributesConfig ? callAttributesConfig : callBaseConfig;
  }
  /**
   * 
   * @param clientId 
   * Below method return true/false based on 
   * client config made in data base either screen pop enable/disabled 
   * @returns 
   */
  screenPopCheck(clientId) {
    let screenAttributesConfig = this.screenPopConfig.get(clientId);
    let screenPopBaseConfig = this.screenPopConfig.get("BASE");
    this.screenPopAttributes = screenAttributesConfig ? screenAttributesConfig : screenPopBaseConfig;
    return (this.screenPopAttributes ? this.screenPopAttributes?.is_enabled?.includes("true") : true);
  }

  /*Checking how many account can allowed in careportal */
  checkMaxCustAccount(min?) {
    let accountCount = this.customerTabs.filter(
      // Code removed for CCR1-2683
      //(x) => ((x.id != 1 && !x.isAdditionalAccOpen))
      (x) => ((!x.isAdditionalAccOpen))
    ).length;

    return min
      ? accountCount <= this.CCTConfigs.MAXMIUM_ACCOUNTS
      : accountCount > this.CCTConfigs.MAXMIUM_ACCOUNTS;
  }

  createCCTConfigObj() {
    let applicationConfigurations = [...Object.keys(this.CCTConfigs)];

    this.appConfigObj?.forEach((element) => {
      if (
        applicationConfigurations.includes(element.fieldName) &&
        (element.groupName == Constants.APP_CONFIG.Account_Group || element.groupName == Constants.APP_CONFIG.APPLICATION_TIMEOUT_Group)
      ) {
        this.CCTConfigs[element.fieldName] = +element.fieldValue;        
      }
    });
  }

  openCustomDialog(
    msg,
    heading,
    buttonLabel1,
    tabType,
    popupType?,
    buttonLabel2?,
    customClass?
  ) {
    // console.log('Metjod openCustomDialog called', tabType);
    this.customDialogData = {};
    this.customDialogData['msg'] = msg;
    this.customDialogData['displayCustomDialog'] =
      tabType == Constants.CCR_Dashboard ? true : false;
    this.customDialogData['displayCustomDialogCS'] =
      tabType == Constants.CUSTOMER_SEARCH ? true : false;
    this.customDialogData['displayCustomDialogCA'] =
      tabType == Constants.CUSTOMER_ACNT ? true : false;
    this.customDialogData['type'] = popupType;
    this.customDialogData['heading'] = heading;
    this.customDialogData['buttonLabel1'] = buttonLabel1;
    this.customDialogData['buttonLabel2'] = buttonLabel2;
    this.customDialogData['customClass'] = customClass;
    //console.log('Metjod openCustomDialog called', this.customDialogData);
  }

  clearCustomerSearchState() {
    this.dataSource = new MatTableDataSource([]);
    this.customerSearchForm = new FormGroup({});
  }
  /*Below method fetched the updated  value of customer type of customer account
   *from ALIS Customer Attribute if the user on live call */
  // updateCustomerTypeDropDown() {
  //   let liveCustomer = this.genesysCallObj?.eventBody?.participants.find(
  //     (x) =>
  //       x?.recording == true &&
  //       x?.recordingState == 'active' &&
  //       x?.['purpose'] == 'customer' &&
  //       x?.['state'] == 'connected'
  //   );
  //   let customerType = liveCustomer?.attributes?.CUSTOMER_TYPE;
  //   let customerParticipantId = liveCustomer?.id;
  //   console.log('customerType in setCustomerTypeDropDown.............................................................. ' + customerType);
  //   console.log('customerType in setCustomerTypeDropDown................ ' + JSON.stringify(liveCustomer));
  //   if (
  //     customerType &&
  //     this.activeCustTab.activeCall &&
  //     !this.activeCustTab.additionalAccount
  //   ) {
  //     this.activeCustTab.customerType = customerType;
  //     this.activeCustTab.customerParticipantId = customerParticipantId;
  //     console.log(
  //       'Successfully set customer type value in setCustomerTypeDropDown....................... '
  //     );
  //   }
  // }

  /**
   * below method handle the client dropdown enable or disable based live call/chat and outbound 
   */
  disableDropdown() {
    return ((this.isLiveCall ||
      ((this.isLiveChat && this.liveChatCTS.length < 2 ) || !this.checkForUnsecuredChat())) &&
      !this.altOutboundCall)
  }

   

  /**
  * Fetches the My Dashboard Left Nav Bar Data based on the selected client.
  * @param clientId - The ID of the selected client.
  * @param layoutId - The ID of the layout.
  * @returns The Left Nav Bar Data for the selected client and layout.
  */
  getDashboardLeftNavData(event) { 
    if (!this.getClientId(this.dashboardForm.get('clientNameDash')?.value)) {
      return;
    }

    this.dashboardLeftNavLoader = true;
    this.dashboardLeftNavTimeoutId = setTimeout(() => {
      this.dashboardLeftNavLoaderMsg = true;
    }, 1 * this.showLoaderMsgThreshold * 1000);
    this.isErrorToHide = true;
    this.selectedSubMenu = '';
    let url = `${Global.domainUrl}${Global.dashboardApi.dashboardLeftNavigation}`;
    let body = {
      clientId: this.getClientId(this.dashboardForm.get('clientNameDash')?.value),
      layoutId: Constants.LAYOUT_ID.DashboardLeftNavigation,
    };
    /* istanbul ignore next */
    this.http.post(url, body, { headers: this.getCommonHeaders(Constants.apiVersions) }).subscribe({
      next: (res: any) => {
        this.dashboardNavBarData.length = 0;
        this.dashboardLeftNavLoader = false;
        this.dashboardLeftNavLoaderMsg = false;
        clearTimeout(this.dashboardLeftNavTimeoutId);
        this.dashboardNavBarData = res?.data?.menuList;
        this.selectedMenu = this.dashboardNavBarData[0]?.id;
        this.dashboardLeftNavError = false;
     
      },
      error: (err) => {
        this.dashboardLeftNavLoader = false;
        this.dashboardLeftNavLoaderMsg = false;
        this.dashboardLeftNavError = true;
        clearTimeout(this.dashboardLeftNavTimeoutId);
        // this.enableAlerts(Constants.ERROR, Constants.AlertMsg.error500);
        this.triggerLog("DASHBOARD-LEFTNAV-API-FAILURE: " + JSON.stringify(err), this.fileName)
      }
    })
  }

/**
 * @author HASHID
 * This method will fetch the required details for temporary address updation through tba GUI
 * by passing the client id and layout id 
 * @param clientId The ID of the selected client.
 * @returns fastpath & action value required to open the tba guil from care portal.
 * 
 */
  getPinRestTempPostAddData(clientId){
    let url = `${Global.domainUrl}${Global.PIN_RESET_TBA_GUI_TEMP_ADD_COMMUNICATION}`;
    let body = {
      clientId: clientId,
      layoutId: Constants.LAYOUT_ID.PinResetTempPostAddress,
    };
    /* istanbul ignore next */
    this.http.post(url, body, { headers: this.getCommonHeaders(Constants.apiVersions) }).subscribe({
      next: (res: any) => {
        this.pinRestTbaGuipostDetails = res?.data?.menuList[0];
      },
      error: (err) => {
        this.pinRestTbaGuipostDetails = [];
      }
    })
  }

  /**
   * Check if the TBA (TBAGUIRegistrationnAuthorized) is registered
   * @returns {boolean} True if TBA is registered,false otherwise
   */
  isTBAGUIRegistrationCompleted() {
    return !!localStorage.getItem("TBAGUIRegistrationnAuthorized");
  }



  /**
   *Checks the link condition to determine if it satisfies a specific requirement.
   *If the link condition is not provided or is invalid JSON, it is considered to be true.
   *If the link condition specifies a function name 'isTBAGUIRegistrationCompleted',
   *it checks if the function returns true. If true, the condition is considered to be true,
   *otherwise, it displays a warning alert and returns false.
   *@param linkCondition - The link condition to evaluate.
   *@returns A boolean value indicating whether the link condition is satisfied or not.
   */
  checkLinkCondition(linkCondition: string): boolean {
    if (!linkCondition) {
      this.triggerLog("There is no TBA linkCondition available.", this.fileName, Constants.ERROR);
      return true;
    }

    let condition;
    try {
      condition = JSON?.parse(linkCondition);
    } catch (error) {
      //console.error('Invalid linkCondition JSON:', error);
      return true;
    }

    if (condition?.conditionParameters?.functionName === 'isTBAGUIRegistrationCompleted') {
      if (this.isTBAGUIRegistrationCompleted()) {
        return true;
      } else {
        this.triggerLog("User is not registered with TBA", this.fileName, Constants.ERROR);
        this.enableAlerts(Constants.WARNING, Constants.TBA_NOT_REGISTERED_MSG);
        return false;
      }
    }

    return true;
  }

  /**
   *Handles the selection of a left navigation bar link.
   *Checks the link condition and performs appropriate actions based on the link type.Below method gets
   called when link is clicked.
   *@param selectedLink - The selected link object from the left navigation bar.
  */
  selectedLeftNavBarLink(selectedLink, account) {
    // Check the link condition before proceeding
    if (this.checkLinkCondition(selectedLink?.link?.condition)) {
      // Perform actions based on the link type
      this.updateLinkTrackingMap(selectedLink?.layoutId != Constants.LAYOUT_ID.DashboardLeftNavigation ? this.activeCustTab.id : Constants.DASHBOARD_LINK_TRACKING, selectedLink?.heading, selectedLink?.link?.linkType);
      switch (selectedLink?.link?.linkType) {
        case Constants.LINK_TYPE.SSO:
          // console.log("SSO");
          // this.updateLinkTrackingMap(selectedLink?.layoutId != Constants.LAYOUT_ID.DashboardLeftNavigation ? this.activeCustTab.id : Constants.DASHBOARD_LINK_TRACKING ,selectedLink?.heading,selectedLink?.link?.linkType);
          this.openSSOLink(selectedLink);
          break;
        case Constants.LINK_TYPE.WEB:
        case Constants.LINK_TYPE.EGAIN:
          // console.log("==WEB LINk==");
          let clientId;
          if (selectedLink?.layoutId === Constants.LAYOUT_ID.DashboardLeftNavigation) {
            clientId = this.dashboardForm.get('clientId')?.value;
          }
          else {
            clientId = this.activeCustTab?.clientId;
          }
          //  this.updateLinkTrackingMap(selectedLink?.layoutId != Constants.LAYOUT_ID.DashboardLeftNavigation ? this.activeCustTab.id : Constants.DASHBOARD_LINK_TRACKING  ,selectedLink?.heading,selectedLink?.link?.linkType);

          this.openWebLink(selectedLink, clientId);
          break;
        case Constants.LINK_TYPE.TBA:
          //   this.updateLinkTrackingMap(selectedLink?.layoutId != Constants.LAYOUT_ID.DashboardLeftNavigation ? this.activeCustTab.id : Constants.DASHBOARD_LINK_TRACKING ,selectedLink?.heading,selectedLink?.link?.linkType);
          this.tbaSubscribe(selectedLink, account);
          break;
        default:
          this.logEvent(Constants.ERROR, Constants.RSN_CODE_LINK_CONFIG_MISSING + ': Link Configuration is missing for link id: ' + selectedLink?.link?.linkId);
          this.enableAlerts(Constants.ERROR, Constants.RSN_CODE_LINK_CONFIG_MISSING + ": " + Constants.AlertMsg.error500);
          break;
      }
    }
  }

  /**
   *Opens a Single Sign-On (SSO) link based on the selected link information.
   *Depending on the layout ID of the selected link, it constructs a model object with the necessary data.
   *Then, it calls the 'getSSOLink' method to retrieve the SSO link from the server.
   *Upon receiving the response, it creates a new tab/window with the SSO link.
   *If an error occurs during the process, it logs the error and displays an error alert.
   *@param selectedLink - The selected link object containing the necessary information.
  */
  openSSOLink(selectedLink: any) {
    let model = {};
    if (selectedLink?.layoutId == Constants.LAYOUT_ID.DashboardLeftNavigation || selectedLink?.layoutId == Constants.LAYOUT_ID.DashboardMyTodo) {
      model = {
        clientId: this.dashboardForm.get('clientId')?.value,
        linkId: selectedLink?.link?.linkId,
      };
    } else if (selectedLink?.layoutId === Constants.LAYOUT_ID.CustomerAccountLeftNavigation || selectedLink?.layoutId == Constants.LAYOUT_ID.CustomerAccountMyTodo) {
      model = {
        clientId: this.activeCustTab?.clientId,
        linkId: selectedLink?.link?.linkId,
        customerSessionId: this.activeCustTab?.customerSessionId,
      };

    }
    this.getSSOLink(model).subscribe({
      next: (res) => {
        let winUrl = URL.createObjectURL(
          new Blob([res], { type: 'text/html' })
        );
      //  this.openNewTab(winUrl);
      const activeTab = ((selectedLink?.layoutId==Constants.LAYOUT_ID.DashboardMyTodo || selectedLink?.layoutId==Constants.LAYOUT_ID.DashboardLeftNavigation)
        ? { customerSessionId: Constants.CCR_Dashboard } : this.activeCustTab);
      this.openExternalLinks(activeTab, winUrl,selectedLink?.link?.linkId);
      },
      error: (error) => {
        console.log(error);
        this.triggerLog("GET-SSO-LINK-FAILURE: "+ JSON.stringify(error), this.fileName);
        if (selectedLink?.layoutId === Constants.LAYOUT_ID.DashboardMyTodo) {
          this.isDbCaseManagementErrorEnabled = true;
        } else if (selectedLink?.layoutId === Constants.LAYOUT_ID.CustomerAccountMyTodo && this.activeCustTab) {
          // this.customerAccountService.activeTabDt.myTodoErrMsg = Constants.CASE_MNGMT_API_FAIL_MSG;
          this.activeCustTab.isCustAccCaseManagementErrorEnabled = true;
        }
        else {
          this.enableAlerts(Constants.ERROR, Constants.AlertMsg.error500);
          this.triggerLog("GET-SSO-LINK-FAILURE"+ JSON.stringify(error), this.fileName);
        }
      },
    });
  }

  /**
   *Retrieves the Single Sign-On (SSO) link by sending a POST request to the server.
   *The provided model is included in the request body.
   *@param model - The data model to be included in the request body.
   *@returns An Observable that resolves to the SSO link response from the server.
   */
   /* istanbul ignore next */
  getSSOLink(model: any): Observable<any> {
    let url = `${Global.domainUrl}${Global.GET_SSO_LINK}`;
    return this.http.post(url, model, {
      headers: this.getCommonHeaders(Constants.apiVersions),
      responseType: 'text',
    });
  }

  errorHandlingIfUrlNotFound(linkData?) {
    const errorMsg = Constants.RSN_CODE_LINK_CONFIG_MISSING_URL + ': Link URL is missing for link id: ' + (linkData?.link?.linkId || '');
    this.logEvent(Constants.ERROR, errorMsg);
    this.triggerLog("WEB-LINK-FAILURE: " + errorMsg, this.fileName);
    this.enableAlerts(Constants.ERROR, Constants.AlertMsg.error500);
  }

  /**
 * Opens a web link with the provided link data and client ID.
 * @param linkData - The link data containing information about the link.
 * @param clientId - The client ID to be used in URL replacement.
 */
  /* istanbul ignore next */
  openWebLink(linkData: any, clientId) {
    if (!linkData || !linkData.link || !linkData.link.linkPropertiesValues) {
      this.errorHandlingIfUrlNotFound(linkData);
      return;
    }
    const linkPropertiesValues = JSON.parse(linkData.link.linkPropertiesValues);
    const webUrl = linkPropertiesValues?.url;
    const queryParameters = linkPropertiesValues.queryParameters?.[0] || false;
    const clientMappingDeliminator = Constants.CLIENT_MAPPING_DELIMINATOR;
    // In case of blank url showing edit message 

    if (!webUrl) {
      this.errorHandlingIfUrlNotFound(linkData);
      return;
    }

    let updatedWebUrl = webUrl
      .replaceAll('#USR.clientId', clientId)
      .replaceAll('#CUS.clientId', clientId);
    let mappedValue = 'NA';
    let replaceKey = '';
    if (webUrl?.includes('#MAPPING')) {

      // Updt logic for remove '-' deliminator Start**
      var mappingString = webUrl?.substring(
        webUrl?.indexOf(clientMappingDeliminator) + 1,
        webUrl?.lastIndexOf(clientMappingDeliminator)
      );
      // Mapping String example #MAPPING.EGAIN.COMMON.CLNT-NAME#
      let splitArray = mappingString?.split('.');
      if (splitArray?.length == 4) {
        let systemName = splitArray?.[1];
        let domainName = splitArray?.[2];
        let attributeName = splitArray?.[3];
        mappedValue = this.getMappedValFromClientSystemData(systemName, attributeName, clientId, domainName);

        if (mappedValue == 'NA' || mappedValue == null) {
          mappedValue=clientId;
          updatedWebUrl = webUrl?.replaceAll(clientMappingDeliminator + mappingString + clientMappingDeliminator, mappedValue);
          console.log('default CP client id assigned when link client id is missing' + updatedWebUrl);
        }
        else {
          updatedWebUrl = webUrl?.replaceAll(clientMappingDeliminator + mappingString + clientMappingDeliminator, mappedValue);
        }
      }
      else {
        console.log('Invalid config in link properties :' + webUrl);
        updatedWebUrl = webUrl?.replaceAll(clientMappingDeliminator + mappingString + clientMappingDeliminator, 'InValidConfig');
      }
      // Updt logic for remove '-' deliminator Start**
      // let splitEqual = webUrl.split('-');
      // let arr = splitEqual?.[1].split('.');
      // let systemName = arr?.[1];
      // let attributeName = '';
      // if (arr?.[2].length > 0 && arr?.[2].includes('/')) {
      //   let attArr = arr?.[2].split('/');
      //   attributeName = attArr?.[0];
      // }
      // else {
      //   attributeName = arr?.[2];
      // }
      //replaceKey = 'ClientID-' + arr?.[0] + '.' + arr?.[1] + '.' + attributeName;

      // if (mappedValue == 'NA') {
      //   updatedWebUrl = webUrl.replaceAll(replaceKey, 'ClientID' + "-" + clientId)
      // }
      // else {
      //   updatedWebUrl = webUrl.replaceAll(replaceKey, 'ClientID' + "-" + mappedValue)
      // }
    }
    const finalWebUrl = queryParameters ? `${updatedWebUrl}?${queryParameters}` : updatedWebUrl;
    this.logMessage(Constants.INFO, 'Opening web link with url: ' + finalWebUrl);
    // if linkType is Egain it will go in openKCWindow funcion else openNewTab
    if (linkData.link.linkType == Constants.LINK_TYPE.EGAIN) {
      const activeTab = (linkData?.layoutId === Constants.LAYOUT_ID.DashboardLeftNavigation
        ? { customerSessionId: Constants.CCR_Dashboard } : this.activeCustTab);
      this.openKCWindow(activeTab, finalWebUrl);
    }
    else {
      const activeTab = (linkData?.layoutId === Constants.LAYOUT_ID.DashboardLeftNavigation || linkData?.layoutId==Constants.LAYOUT_ID.DashboardMyAppointments
        ? { customerSessionId: Constants.CCR_Dashboard } : this.activeCustTab);
      this.openExternalLinks(activeTab, finalWebUrl)//this.openNewTab(finalWebUrl);
    }
  }


  /*@ Vamsi krishna
 @tbaTransId deails
 Below method to extract TBA TransDetails and update in TBA model **/

 getTransDetails(tbaTransId : any, domain? : string, account? : any) {

  let transId = '';
  //logic changed as per CCR5-2120 transID will be fetched from idMapping tranID field if empty fetch it old way
 if (account) {
  // Safe to access this.activeCustTab.tabData.tabData
  const filteredMappings = this.activeCustTab.tabData.tabData.idMapping.
          filter(mapping => mapping.platformType.includes('TBA'));
   if (filteredMappings?.length === 1) {
     transId = filteredMappings[0].tranId;
   }
   if(filteredMappings?.length > 1 && domain) {
     const domainFilteredMappings = filteredMappings.filter(mapping => mapping.domains.includes(domain));
     if(domainFilteredMappings?.length > 0)
        transId = domainFilteredMappings[0]?.tranId;
   }
  }
   //old logic for transId invoked if transId not in IdMapping
   if(transId ==='') {
    if(account){
    let currentTabIdMappingArr = this.activeCustTab?.tabData?.tabData?.idMapping;
      if(currentTabIdMappingArr?.length == 1 && currentTabIdMappingArr[0]?.domains!= domain){
      let domainsList= currentTabIdMappingArr[0]?.domains.split(',');
      if(domainsList?.length==1){
        domain=domainsList[0];
      }else{
        domain="COMMON";
      }
      }}
      
      transId = tbaTransId?.data?.[tbaTransId.clientId + "-TBA-GUI-COMMON-TRANS-ID"]?.targetSystemAttributeValue;
      if(domain) {
        const domainTransId = tbaTransId?.data?.[tbaTransId.clientId + "-TBA-GUI-"+ domain +"-TRANS-ID"]?.targetSystemAttributeValue;
        if (domainTransId) { 
          transId = domainTransId;
        }
     }
    }
   
   
   let model = {
    tranId: transId,
    lifecycle: tbaTransId?.data?.[tbaTransId.clientId + "-TBA-GUI-COMMON-LIFECYCLE"]?.targetSystemAttributeValue
  }
  return model;
}

  /* @Vamsi.Pamidala
  Below method access the TBA Customer Account by Care Portal**/
  openTbaWindow(menu, Account): Observable<any> {
    // console.log('Method tbaCustomerAccount called');
    let payloadTransId:any='';
    let payloadLifecycle:any='';
    let tbaTransId: any, tbaDetails;
    let internalPlatformIdTBA:any='';

    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    const url = `https://localhost:${port}/tbagui`;
  
    let _action = '';
    let _fastpath = '';
    let _funcId = '';
  
    if(menu){
      if(menu?.link?.linkPropertiesValues){
       _action = JSON.parse?.(menu?.link?.linkPropertiesValues)?.action ?? '';
     _fastpath = JSON.parse?.(menu?.link?.linkPropertiesValues)?.fastpath ?? '';
     _funcId = JSON.parse?.(menu?.link?.linkPropertiesValues)?.['func-id'] ?? '';
    }
   }
    //const linkLabel = menu?.heading;

    if (Account) {
      
      tbaTransId = this.clientSystemIds.find(x => x.clientId == this.activeCustTab.clientId);
      tbaDetails = this.getTransDetails(tbaTransId, menu?.domain, true);
    } else {
      tbaTransId = this.clientSystemIds.find(x => x.clientId == this.dashboardForm.get('clientId')?.value);
      tbaDetails = this.getTransDetails(tbaTransId, menu?.domain, false);
    }
 
    if (this.dataBaseSelecterMap[this.activeCustTab.clientId]) {
      payloadTransId = this.dataBaseSelecterMap[this.activeCustTab.clientId]?.['TRANS-ID'];
      payloadLifecycle = this.dataBaseSelecterMap[this.activeCustTab.clientId]?.LIFECYCLE;
    } else {
      payloadTransId = (Account && tbaDetails?.tranId ? tbaDetails?.tranId : "");
      payloadLifecycle = (Account && tbaDetails ? tbaDetails?.lifecycle : tbaDetails?.lifecycle || (this.Prod_lifeCycle ? Constants.LIFECYCLE : 'A'));
    }

    let currentTabIdMappingArr = this.activeCustTab?.tabData?.tabData?.idMapping;
    let platformTypeTBA =  _.filter(currentTabIdMappingArr, (each) => each?.platformType.includes(Constants.TBA_));
    let domainIdMap = _.filter(currentTabIdMappingArr, (each) => {
       return  each?.domains.includes(menu?.domain)
      });

    if(platformTypeTBA?.length==1){
      internalPlatformIdTBA = platformTypeTBA[0]?.platformInternalId;
    }
    else{
      if(domainIdMap?.length == 1){
        internalPlatformIdTBA = domainIdMap[0]?.platformInternalId;
      }
      else{
    /**Case when 2 entries of same domainName found with unique roleType .At this case , filter domainIdMap on basis of defaultRole 
     * selected  /CCR1-10750 ****/
     
      let that = this;
       let obj  = _.find(domainIdMap, (each) => {
         return each?.roleType == this.activeCustTab.roleObj?.roleType
        })
       internalPlatformIdTBA = obj?.platformInternalId ;
     }
   }
  // added check to update show and hide tba window CCR3-12538
   if(internalPlatformIdTBA){
    this.activeCustTab.tabData.tabData.platformInternalId = internalPlatformIdTBA;     
   }

    let payload = {
      focus: '',
      sessionId: sessionId,
      lifecycle:  payloadLifecycle,
      tranId: payloadTransId,
      prsnIntnId: Account ? ( internalPlatformIdTBA || this.activeCustTab?.tabData?.tabData?.platformInternalId || this.activeCustTab?.id) : '',
      action: _action,
      lockedCd: '',
      fastpath: _fastpath,
      funcId: _funcId,
      aci: '',
      tac: '',
      vrs: '',
      refId: '',
      docId: '',
      reasonCd: '',
      origId: '',
      actId: '',
      actIdType: '',
    };

    if (this.activeCustTab?.customerSessionId) {
      this.tbaPayloadMap.set(this.activeCustTab?.customerSessionId, payload);
    }
    // In case no customer account has been opened and tba has been opened from Dashboard.
    else {
      this.tbaPayloadMap.set(Constants.DASHBOARD_TBA_PAYLOAD, payload);
    }

    console.log('tbaCustomerAccount url', url);
    let headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(url, payload, {
      headers: headers,
      responseType: 'text',
    });
  }


  updateShowHideInTba(_action, Tab) {
    let tbaTransId = this.clientSystemIds.find(x => x?.clientId == Tab?.clientId);
    let tbaDetails = this.getTransDetails(tbaTransId, undefined as any, true);
    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    const url = `https://localhost:${port}/tbagui`;
    let payload = {
      focus: '',
      sessionId: sessionId,
      lifecycle: tbaDetails?.lifecycle || (this.Prod_lifeCycle ? Constants.LIFECYCLE : 'A'),
      tranId: tbaDetails?.tranId || "",
      prsnIntnId: Tab?.platformInternalId || "",
      action: _action,
      lockedCd: '',
      fastpath: '',
      funcId: '',
      aci: '',
      tac: '',
      vrs: '',
      refId: '',
      docId: '',
      reasonCd: '',
      origId: '',
      actId: '',
      actIdType: '',
    };
    let headers = new HttpHeaders().append('Content-Type', 'application/json');
    this.http.post(url, payload, {
      headers: headers,
      responseType: 'text',
    }).subscribe({
      next: (res) => {
        /*istanbul ignore next*/
        if (res && !res.includes('0:')) {
          this.logEvent(Constants.ERROR, res);
          if (res) this.enableAlerts(Constants.WARNING, Constants.TBA_CONS[200] + res);
        }
        else
          console.log("TbaWindow opened ");
      },
      error: (error) => {
        this.logEvent(Constants.ERROR, error?.error + ":" + _action);
        if (error?.error == 'Invalid Environment.') this.enableAlerts(Constants.ERROR, this.Prod_lifeCycle ? Constants.TBA_CONS['Prod_Invalid Environment'] : Constants.TBA_CONS['Invalid Environment.']);
        else this.enableAlerts(Constants.WARNING, Constants.TBA_NOT_REGISTERED_MSG);
      }
    });
  }


  tbaSubscribe(menu, active) {
    this.triggerLog("TBA Window initiated for layoutId - " + menu?.layoutId + " | linkId- " + menu?.link?.linkId, this.fileName, Constants.DEBUG);
    this.openTbaWindow(menu, active).subscribe({
      next: (res) => {
        /*istanbul ignore next*/
        if (res) {//&& !res.includes('0:')
          this.logEvent(Constants.ERROR, res);
          if (res?.includes('65290')) {
            this.enableAlerts(Constants.WARNING, Constants.TBA_CONS.TOO_MANY_TBA_WINDOW);          
          }
          else if (res) {
            this.enableAlerts(Constants.WARNING, Constants.TBA_CONS[200] + res);          
          }       
        }
        else 
          console.log("TbaWindow opened ");
        if (res && res.includes('0:'))
          this.triggerLog("Result Success | Response Type - " + res + " | Link Label - " + menu?.heading + " | linkId- " + menu?.link?.linkId, this.fileName, Constants.DEBUG);
        else
          this.triggerLog("Result Failed | Response Type - " + res + "  | Link Label - " + menu?.heading + " | linkId- " + menu?.link?.linkId, this.fileName, Constants.ERROR);
      },
      error: (error) => {
        this.logEvent(Constants.ERROR, error?.error + ":" + menu?.link?.linkId);      
        if (error?.error == 'Invalid Environment.') {
          this.enableAlerts(Constants.ERROR, Constants.TBA_CONS['Invalid Environment.']);         
        }
        else {
          this.enableAlerts(Constants.WARNING, Constants.TBA_NOT_REGISTERED_MSG);        
        }

        this.triggerLog("Result Error | : Response Type - " + error + "  | Link Label - " + menu?.heading + " | linkId- " + menu?.link?.linkId, this.fileName, Constants.ERROR);
      }
    })
  }
  /**
   * This method can we used to log events. This is created to use common logging mechanism in angular application
   * and if in future this method can be further extended to send logs to SQS/new relic.
   * @param severity 
   * @param msg 
   */
  logEvent(severity, msg) {

    let logModel = {
      'userSession': this.sessionId,
      'emailId': this.emailId,
      'timeStamp': new Date()
    }
    // console.log("====Starting to log Event===");
    // console.log('User details inside logEvent: ' + JSON.stringify(logModel));
    this.logMessage(severity, msg);
    // console.log("====Log Event End===========");
  }
  /**
   * This method is used to log error/info/warn messages based on severity.
   * @param severity 
   * @param msg 
   */
  logMessage(severity, msg) {
    switch (severity) {
      case Constants.ERROR:
        console.error(msg);
        break;
      case Constants.WARNING:
        console.warn(msg);
        break;
      case Constants.INFO:
        console.log(msg);
        break;
    }
  }

  /**
  Retrieves the dashboard "My Todo" data based on the provided event.
  @param event - The event object containing the client ID.
  */
  getDashboardMyTodo(event) {
    if (!this.getClientId(this.dashboardForm.get('clientNameDash')?.value)) {
      return;
    }
    this.dbMyTodoloaderTimeoutId = setTimeout(() => {
      this.showDbMyTodoLoaderMsg = true;
    }, 1 * this.showLoaderMsgThreshold * 1000);
    this.isDbCaseManagementErrorEnabled = false;
    this.hasNoDbCaseManagementData = false;
    this.dbCaseManagementLoader = true;

    let url = `${Global.domainUrl}${Global.dashboardApi.dashboardLeftNavigation}`;
    let body = {
      clientId: this.getClientId(this.dashboardForm.get('clientNameDash')?.value),
      layoutId: Constants.LAYOUT_ID.DashboardMyTodo
    };
    /* istanbul ignore next */
    this.http.post(url, body, { headers: this.getCommonHeaders(Constants.apiVersions) }).subscribe({
      next: (res: any) => {
        clearTimeout(this.dbMyTodoloaderTimeoutId);
        this.dbCaseManagementLoader = false;
        this.showDbMyTodoLoaderMsg = false;
        this.hasNoDbCaseManagementData = false;
        this.isDbCaseManagementErrorEnabled = false;
        if (res?.data?.menuList.length > 0) {
          this.dashboardMyTodoData = res?.data?.menuList;
        }
        else {
          this.dashboardMyTodoData = res?.data?.menuList;
          this.isDbCaseManagementErrorEnabled = true;
          this.hasNoDbCaseManagementData = true;
        }
        ;
        console.log(res);
      },
      error: (err) => {
        this.triggerLog("GET-DASHBOARD-MYTODO-FAILURE: " + JSON.stringify(err), this.fileName);
        clearTimeout(this.dbMyTodoloaderTimeoutId);
        this.dbCaseManagementLoader = false;
        this.showDbMyTodoLoaderMsg = false;
        this.isDbCaseManagementErrorEnabled = true;
        console.log(err);
      }
    })
  }

  /**This method is responsible for clearing cache and session storage data related to Genesys and TBA registration.
  It removes specific items from the localStorage and sessionStorage, resets certain variables, and updates a flag **/
  cacheClearGenesysAndTBARegistration(createNewSession) {
    localStorage.removeItem('purecloud_auth_data');
    localStorage.removeItem('userId');
    sessionStorage.removeItem('connectToGenesys');
    sessionStorage.removeItem('ALIS_region');
    sessionStorage.removeItem('ALISRegisteredRegionObj');
    sessionStorage.removeItem('isLiveCall');
    sessionStorage.removeItem('isLiveChat');
    localStorage.removeItem('isConnected');
    localStorage.removeItem('TBAGUIStatusConnected');
    localStorage.removeItem('TBAGUIRegistrationnAuthorized');
    //sessionStorage.removeItem('tba_sessionId');
   // sessionStorage.removeItem('tba_port');
    if (!createNewSession) {
      this.ALISRegistrationCardMsgAfterSessionPopUp = true;
    }

  }

  updateUserInElasticCacheObs(payload): Observable<any> {
    return this.http.post(Global.domainUrl + Global.UPDATE_USER_EC, payload, {
      headers: this.getCommonHeaders(Constants.apiVersions),

    });
  }

  updateUserInElasticCache(payload) {
    this.updateUserInElasticCacheObs(payload).subscribe({
      next: () => {
        this.logMessage(Constants.INFO, 'updateUserInElasticCache Data successfully updated in EC for user: ' + this.sessionId);
      },
      error: (error) => {
        this.triggerLog("UPDATE-USER-ELASTIC-CACHE-FAILURE: " + JSON.stringify(error), this.fileName);
        this.logMessage(Constants.ERROR, 'updateUserInElasticCache Error while updating data in EC for user: ' + this.sessionId);
      }
    })
  }


  captureLogsDb(error: any, logType: string) {
    if (this.isLogEnabledUser.includes(logType)) {
      let logErrObj = this.createAngluarLogsObject(error, logType, null);
      this.awsSQSService.sendAngularLogsToSQS(logErrObj);
    }
  }

    /**
   * logs user interaction to SQS if any refresh button intraction intiated by the user
   * @author :HASHID
   * CCR3-6969 
   */
  captureAlisIntractToDb(usage: string, logType: string) {
    if (this.isLogEnabledUserAlisIntr.includes(logType)) {
      let logErrObj = this.createAngluarLogsObject(usage, logType, null);
      this.awsSQSService.sendAngularLogsToSQS(logErrObj);
    }
  }

  liveIcon(tab: Tab, type) {
    if (
      type == 'call' && tab.channel == Constants.conversion.call &&
      (tab.activeCall ||
        (!tab.activeCall &&
          !tab.activeChat &&
          tab.additionalAccount &&
          tab.isAdditionalAccOpen == Constants.conversion.call))
    ) {
      return true;
    } else if (
      type == 'chat' && tab.channel == Constants.conversion.chat &&
      (tab.activeChat ||
        (!tab.activeChat &&
          tab.additionalAccount &&
          tab.isAdditionalAccOpen == Constants.conversion.chat)) &&
      !tab.activeCall &&
      !tab.isWrapupDone
    )
      return true;
    else return false;
  }

  getMsgPart1() {
    return this.activeCustTab.repeatAlertMsg?.split(':')[0];
  }

  getMsgPart2() {
    return this.activeCustTab.repeatAlertMsg?.split(':')[1];
  }

  /**CCR3-3401
      * @author Vamsi.pamidala
      * to handle tba hide and show condiions 
      */
  hideAndShowTBA(action, customerSessionId) {//'HIDE_PERSON' SHOW_PERSON
    if (this.activeCustTab?.customerSessionId && this.tbaPayloadMap?.size && this.tbaPayloadMap.get(this.activeCustTab?.customerSessionId)) {
      this.updateShowHideInTba(action, { clientId: this.activeCustTab.clientId, platformInternalId: this.activeCustTab?.tabData?.tabData?.platformInternalId });
    }
  }

  /**
   * CCR1-4618
   * @author :Pooja
   * @param tab 
   * @param url 
   */
  openUpdateNewTab(tab, url) {
    let id = '1';
    let activeTab = this.newTabId.get(id);
    console.log("activeTab", activeTab)
    if (activeTab && !activeTab?.closed) {
      activeTab.location.replace(url);
      // activeTab.focus();
    } else {
      if (activeTab)
        this.newTabId.delete(id)

      this.newTabId.set(id, window.open(url, '_blank'));
    }
  }
  /**
   * Closing ALS Tab on closure of Care Portal
   * CCR1-6134
   */
  closeALSTab() {
    let id = '1';
    let activeTab = this.newTabId.get(id);
    if (activeTab && !activeTab?.closed) {
      activeTab.close();
      this.newTabId.delete(id);
    }
  }


  /**CCR3-3212 POC
   * @author Vamsi.pamidala
   * @param  
   * open New tab outside of Care Portal but refrence point holding in Care portal,
   * when user close account close that account related eGain tab 
   * holding refrence details based on conversationId/customerSessionId
   *
   */
  openKCWindow(Tab, url) {
    let id = Tab?.additionalAccount ? Tab?.tabData?.parentData?.customerSessionId : Tab.customerSessionId;
    let activeTab = this.eGainContainerList.get(id);// verfiying the eGain tab is avaible or not
    //Validate Kc tab is already open for selected customer account 
    if (activeTab && !activeTab?.closed) {
      activeTab.location.replace(url);
      activeTab.focus();
    } else {
      if (activeTab) this.eGainContainerList.delete(id)
      this.eGainContainerList.set(id, window.open(url, '_blank'));
    }
  }

  /**CCR3-15 POC
  * @author Vamsi.pamidala
  * @param  when user close customer account parallel close eGain tab which one is tied with that account
  */
  closeKCWindow(Tab) {
    if (Tab.additionalAccount || Tab?.additionalAccountId) return;
    else {
      let id = Tab?.customerSessionId;
      let activeTab = this.eGainContainerList.get(id);

      if (activeTab) {
        activeTab?.close()
        this.eGainContainerList.delete(id);
      }
    }
  }

  closeAllKcWindow() {
    this.eGainContainerList.forEach(x => {
      if (x && !x?.closed) {
        x.close();
        // this.eGainContainerList.delete(x);
      }
    })
  }

  /**CCR3-4580
  * @author Amarjeet kumar
  * @param1  Tab -  Customer Account details
  * @param2  url -  external tab url
  * open New tab outside of Care Portal but refrence point holding in Care portal,
  * when user close account close that account related external tab 
  * holding refrence details based on ustomerSessionId   *
  */
  openExternalLinks(Tab, url, ssoUrl?) {
    let openedUrl = false;
    let id = Tab?.additionalAccount ? Tab?.tabData?.parentData?.customerSessionId : Tab.customerSessionId;
    let activeTab = this.externalTabList.get(id);
    //Validate  tab is already open for selected customer account or dashboard
    /* istanbul ignore next */
    if (activeTab) {
      activeTab.forEach(x => {
        if ((x.key == url || x.key == ssoUrl) && !x.value?.closed) {
          x.value.location.replace(url);
          x.value.focus();
          openedUrl = true;
        }

      })
      if (id && !openedUrl) {
       let externalTab = this.externalTabList?.get(id);
       if(externalTab){
        // CCR3-12487 Checkmarx issue Fix - Unsafe use of Target blank
        // generate a distinct window name using the session ID and tab count.
        const uniqueWindowName = 'external_' + id + '_' + (externalTab.length + 1);
        externalTab.push({ key: ssoUrl?ssoUrl:url, value: window.open(url, uniqueWindowName) });
       }
      }
    }
  }
  
  /**CCR3-4580
  * @author Amarjeet kumar
  * @param1  Tab -  Customer Account details  
  * when user close account close that account related external tab  
  */
  closeExternalTabs(Tab) {
    if (Tab.additionalAccount || Tab?.additionalAccountId) return;
    else {
      let id = Tab?.customerSessionId;
      let activeTab = this.externalTabList.get(id);
      /* istanbul ignore next */
      if (activeTab) {
        activeTab?.forEach(x => {
          if (x && x.value && !x.value?.closed) {
            x.value.close();
          }
        })
      }
    }
  }

  /**CCR3-4580
  * @author Amarjeet kumar  
  * when user logged out or session logout, we are closing all external tab those were opened via Care Portal.
  */
  closeAllExternalTabs() {

    for (const parentValue of this.externalTabList.values()) {
      for (const childValue of parentValue) {
        /* istanbul ignore next */
        if (childValue && childValue.value && !childValue.value?.closed) {
          childValue.value.close();
        }
      }
    }
  }


  validateNullAndEmpty(value) {
    return (value != "NA" && value && value != "null");
  }

  /**
   * Main intent of below method to validate
   * attribute is not null /0/undefined/
   * used for externalLeaveId and employeeId as of now
   * @param attribute 
   * @author :Pooja
   * @returns 
   */
  validateALISAttributeValue(attribute) {
    if (attribute && attribute != null && attribute != undefined && attribute != 0) {
      return attribute;
    }
    else {
      return 'NA';
    }

  }

  isConversationIdPresent() {
    if (
      this.activeCustTab.conversationId &&
      this.activeCustTab.conversationId != 'NA'
    )
      return true;
    else return false;
  }

  /*
  Method used to set angular logging object to be sent to postgres db via SQS

  @message message to be sent
  @logtype error/usage/debug
  @tab current tab

  */
  createAngluarLogsObject(message, logType, tab) {

    let logData = {
      userId: this.lanId,
      date: new Date().toISOString(),
      timestamp: this.getCurrentTimeStamp(),
      clientID: tab != 'N/A' ? tab?.clientId : this.dashboardForm.get('clientId')?.value,
      globalId: tab != 'N/A' ? tab?.id : 'N/A',
      usersessionId: this.sessionId,
      customersessionId: tab != 'N/A' ? tab?.conversationId : 'N/A',
      loger: logType,
      level: "usage",
      message: message,
      action: "sendAngularLogsToSQS",
      containerName: "browser",
      applicationType: "angular",

    };

    return logData;

  }

  getCurrentTimeStamp() {
    const currentDate: Date = new Date();
    const hours: string = ('0' + currentDate.getUTCHours()).slice(-2);
    const minutes: string = ('0' + currentDate.getUTCMinutes()).slice(-2);
    const seconds: string = ('0' + currentDate.getUTCSeconds()).slice(-2);
    const formattedTime: string = `${hours}:${minutes}:${seconds}`;
    return formattedTime;
  }

  /*
  Update link tracking map . Map contains udpid and string od links clicked

  @Linkey : udpid or DASHBOARD-LINK in case of dashboard
  @libklable: name of link
  @link type : type of link 
  */
  updateLinkTrackingMap(linkKey, linklable, linkType) {
    let messageString: string = this.linkTrackingMap?.get(linkKey);

    if (!this.checkLinkTrackingCondition(linkType)) {
      return;
    }

    if (messageString) {
      if (messageString.indexOf(linklable) == -1) {
        messageString = messageString + " | " + linklable + ":" + linkType;
      }
    }
    else {
      messageString = linklable + ":" + linkType;
    }

    this.linkTrackingMap.set(linkKey, messageString);
    console.log('linkTrackingMap: ' + [...this.linkTrackingMap]);
  }

  checkLinkTrackingCondition(linkType) {
    let linkTrackingObj = this.getObjFromConfigObj("ENABLE_TRACKING");

    if (!linkType) {
      return false;
    }

    let enableTracking = linkTrackingObj?.['fieldValue'] ?? 'NONE';

    if (enableTracking) {

      if (enableTracking?.indexOf('ALL') != -1) {
        return true;
      }
      else if (enableTracking?.indexOf('NONE') != -1) {
        return false;
      }

      else if (enableTracking?.indexOf(Constants.LINK_TYPE.TBA) != -1 && linkType == Constants.LINK_TYPE.TBA) {
        return true;
      }

      else if (enableTracking?.indexOf(Constants.LINK_TYPE.EGAIN) != -1 && linkType == Constants.LINK_TYPE.EGAIN) {
        return true;
      }

      else if (enableTracking?.indexOf(Constants.LINK_TYPE.WEB) != -1 && linkType == Constants.LINK_TYPE.WEB) {
        return true;
      }

      else if (enableTracking?.indexOf(Constants.LINK_TYPE.SSO) != -1 && linkType == Constants.LINK_TYPE.SSO) {
        return true;
      }


    }
    return false;

  }

  getParticipantId() {
    return this.genesysCallObj?.eventBody?.participants.find(
      (x) =>
        x?.['purpose'] == 'customer' &&
        x?.['state'] == 'connected'
    )?.id;
  }

  /**
  * Below method handles show a model prompt alert msg with dynmic seconds and buttons 
  */
  openTimeoutDialog() {

    this.openDialog({
      title: 'Still working?',
      subheading: '',
      message: Constants.Timeout_Msg,
      firstbutton: Constants.buttonEnum.stillWorking,
      secondbutton: Constants.buttonEnum.logOut,
      crossIcon: false,
      comingFrom: 'customer-account',
      additionalClass: 'timeout-modal',
      id: 'timeOutPopUp'
    });
  }

  //get time out details 
  public getTimeOutDetails() {
    return this.timeOutDetails.asObservable();
  }

  //get set out details 
  public setTimeOutDetails(data) {
    this.timeOutDetails.next(data)
  }

  /**
 * Handles the timeout during a live interaction.
 * Closes the timeout popup, clears the timeout popup interval, and sets the timeout details based on conditions.
 */
  handleTimeoutDuringLiveInteraction() {
    // Close the timeout popup if it exists
    this.clearInterval = true;//warning icon and clear intervel both will update
    this.dialog.getDialogById('timeOutPopUp')?.close();
    //clearInterval(this.timemoutPopUpInteraval);

    // Check if the maximum customer account is reached and there is no ongoing live call
    if (this.checkMaxCustAccount() && !this.checkLiveCallAccount() && !this.checkLiveChatAccount()) {
      this.setTimeOutDetails({ 'watch': true, 'stop': false });
    } else {
      if (this.isLiveCall || this.isLiveChat) {
        this.setTimeOutDetails({ 'watch': false, 'stop': true });
      }
    }
  }

  /**
   * Checks if there is an ongoing live call in any customer tab.
   * @returns {boolean} True if there is an active call, otherwise false.
   */
  checkLiveCallAccount() {
    return this.customerTabs.some(x => x.activeCall === true);
  }

  /**
  Checks if there is any live chat account active.
  @returns {boolean} True if there is any live chat account active, otherwise false.
  */
  checkLiveChatAccount() {
    return this.customerTabs.some(
      x => x.activeChat === true &&
        x.iconClass === 'fa-solid green' &&
        x.isWrapupDone === false &&
        x.additionalAccount === false
    );
  }

  /**
  Checks if a chat with the provided conversation ID is active but not wrapped up.
  @param {string} conversationId - The ID of the conversation to check.
  @returns {boolean} True if the chat is active but not wrapped up, otherwise false.
  */
  checkDisconnectChatButNotWrapUp(conversationId) {
    return this.customerTabs.some(
      x => x.conversationId === conversationId &&
        x.activeChat === true &&
        x.iconClass === 'green' &&
        x.isWrapupDone === false &&
        x.additionalAccount === false
    );
  }

  showAndHideCustomerDocuments(tab) {
    this.customerTbaDocumentsMap.forEach((value, key) => {
      this.hideCustomerDocuments(key);
    });

    this.showCustomerDocuments(tab?.customerSessionId);
  }

  showCustomerDocuments(customerSessionId) {
    if (this.customerTbaDocumentsMap.has(customerSessionId)) {
      this.tbaAPICallToShowHideDocument(customerSessionId, "true");
    }
  }

  hideCustomerDocuments(groupName) {
    this.tbaAPICallToShowHideDocument(groupName, "false");
  }

  tbaAPICallToShowHideDocument(groupName, visibility) {
    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    const url = 'https://localhost:' + port + '/doc/' + sessionId + '/' + groupName;
    const req = new XMLHttpRequest();
    req.open("PATCH", url);
    req.setRequestHeader("Content-Type", "application]/json");
    var data = JSON.stringify({ "visible": visibility });
    req.send(data);
  }

  fullySecuredCall() {
    return this.customerTabs.filter(
      (x) =>
        (x.activeCall && !x.additionalAccount && x.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ||
        (x.activeChat && !x.additionalAccount && x.CS_SECURITY_LEVEL == Constants.securityLevels.SL4)
    ).length;
  }

  checkForUnsecuredChat() {
    let tab = this.customerTabs.find(
      (x) =>
        (x.activeChat && !x.additionalAccount && x.CS_SECURITY_LEVEL != Constants.securityLevels.SL4)
    )
    if (tab) return false;
    else return true
  }

  /**
* So the requirement was for few tools like AM360 or leavePro 
* clientId was different for clientId in careportal 
* so a mapping is present in clientMapping API  amnd from that mapped data,
* we need to find out their clientID mapped to our client and then form their URLS.
* CCR5-265
* Here key = "00095-AM360-COMMON-CLNT-ID"
* @param systemName  - AM360
* @param attributeName - CLNT_ID
* @returns 
* @author :Pooja
*/

  /* istanbul ignore next */
  getMappedValFromClientSystemData(systemName, attributeName, clntId, domainName?) {
    let localClntId = 'NA';
    localClntId = this.activeCustTab.clientId;
    if (localClntId == 'NA' || localClntId == '' || !localClntId) {
      localClntId = clntId;
    }
    let data = this.clientSystemIds.find(x => x.clientId == localClntId);
    let key = '';
    if (domainName && domainName != 'undefined') {
      key = localClntId + "-" + systemName + "-" + domainName + '-' + attributeName;
    }
    else {
      key = localClntId + "-" + systemName + "-" + 'COMMON' + '-' + attributeName;
    }
    if (data?.data?.[key]) {
      return data?.data[key]?.targetSystemAttributeValue;
    }
    else
      return 'NA';
  }

  /** Removes the "tel:" prefix from a phone number string, if present.
  * @param {string} phoneNumber The phone number string possibly containing the "tel:" prefix.
  * @returns {string} The phone number string with the "tel:" prefix removed, if present.
  */
  removeTelPrefix(phoneNumber: string): string {
    if (phoneNumber && phoneNumber.startsWith("tel:")) {
      return phoneNumber.substring(4);
    } else {
      return phoneNumber;

    }
  }

  /**
   * 
   */
  getClientId(clientName) {

    let item = this.sortedClientList?.filter(
      a => a.clientName == clientName
    );

    return item[0]?.clientId;
  }

  getClientName(clientId) {

    let item = this.sortedClientList?.filter(
      a => a.clientId == clientId
    );

    return item[0]?.clientName;
  }

  /**
 * Fetches the My Dashboard Left Nav Bar Data based on the selected client.
 * @param clientId - The ID of the selected client.
 * @param layoutId - The ID of the layout.
 * @returns The Left Nav Bar Data for the selected client and layout.
 */
  getUnknownCallerLeftNavData(event) {
    this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavError = false;
    this.activeCustTab.unknownCallerLeftNav.unknownCallerNavBarData = [];
    this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavLoader = true;
    this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavTimeoutId = setTimeout(() => {
      this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavLoaderMsg = true;
    }, 1 * this.showLoaderMsgThreshold * 1000);
    this.isErrorToHide = true;
    this.activeCustTab.unknownCallerLeftNav.selectedSubMenu = '';
    let url = `${Global.domainUrl}${Global.dashboardApi.dashboardLeftNavigation}`;
    let body = {
      clientId: event?.value,
      layoutId: Constants.LAYOUT_ID.DashboardLeftNavigation,
    };
    /* istanbul ignore next */
    this.http.post(url, body, { headers: this.getCommonHeaders(Constants.apiVersions) }).subscribe({
      next: (res: any) => {
        this.activeCustTab.unknownCallerLeftNav.unknownCallerNavBarData.length = 0;
        this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavLoader = false;
        this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavLoaderMsg = false;
        clearTimeout(this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavTimeoutId);
        this.activeCustTab.unknownCallerLeftNav.unknownCallerNavBarData = res?.data?.menuList;
        this.activeCustTab.unknownCallerLeftNav.selectedMenu = res?.data?.menuList[0]?.id;
        this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavError = false;
      },
      error: (err) => {
        this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavLoader = false;
        this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavLoaderMsg = false;
        this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavError = true;
        clearTimeout(this.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavTimeoutId);
        this.triggerLog("unknownCaller-LEFTNAV-API-FAILURE: " + JSON.stringify(err), this.fileName);
      }
    })
  }


  displayNoDataMsgOnClientInfoCard(clientId) {
    if (this.clientInfoCard.clientInfoVSClientIdMap[clientId]) {
      if (this.clientInfoCard.clientInfoVSClientIdMap[clientId]?.length == 0) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return true;
    }
  }

  turnSimulationModeOff() {
    this.activeLink = Constants.CCR_Dashboard;
    this.router.navigate(['/dashboard'], {
      skipLocationChange: true,
    });
    let dashSelTab: any = _.find(
      this.items,
      (each) => each.id == Constants.CCR_Dashboard
    );
    dashSelTab['selected'] = true;

    setTimeout(() => {
      this.simulationData.isSimulationToggleOn = false;
      sessionStorage.setItem('isSimulationMode', 'false');
      this.simulationData.isSimulationModeActive = false;
      this.items = this.items?.filter(items => items?.id != 'simulation');
    }, 250);


  }

  turnSimulationModeOn() {
    let earlierSelectedItem: any = _.find(
      this.items,
      (each) => each.selected == true
    );

    earlierSelectedItem['selected'] = false;
    this.activeLink = Constants.SIMULATION_MANAGER;
    let item = { name: 'Simulation Manager', selected: false, id: 'simulation' };
    let simTab = this.items?.filter(item => item?.id == 'simulation');
    if (simTab?.length == 0)
      this.items.push(item);

    this.router.navigate(['/simulation-manager'], { skipLocationChange: true });

    let dashSelTab: any = _.find(this.items, (each) => each.id == Constants.SIMULATION_MANAGER);
    dashSelTab['selected'] = true;

    this.simulationData.isSimulationToggleOn = true;
    sessionStorage.setItem('isSimulationMode', 'true');
    this.simulationData.isSimulationModeActive = true;
      
   

  }


  /**
   * 
   * @param alisAttributes
   * @param clientId 
   * @returns 
   * @author:Pooja
   */
  getValueFromALISAttributes(alisAttributes, clientId, udpAttribute) {
    let alisAttribute = this.getALISAttributeFromClientConfigMap(clientId, udpAttribute);
    return this.validateALISAttributeValue(alisAttributes?.[alisAttribute]);
  }

  /**
   * 
   * @param clientId Below method will return which attribute to look in
   * ALIS Object 
   * {\"screenpop-alis-attribute-name\":\"PersonID\",
   * \"screenpop-udp-attribute-name\":\"platformExternalId\",
   * \"autolaunch-eeid-alis-attribute-name\":\"PersonID\",
   * \"autolaunch-leaveid-alis-attribute-name\":\"ExternalLeaveID\"}",
   * @param attributeKey 
   * @returns 
   * @author:Pooja
   */

  getALISAttributeFromClientConfigMap(clientId, attributeKey) {
    if (this.isLiveCall) {
      return this.callAttributes?.[attributeKey];
    }

    if (this.isLiveChat) {
      return this.chatAttributes?.[attributeKey]
    }
  }

  /**
     * Below method return each config object from array of Valid Values Configuration
     * as per field Name
     */
  getObjFromConfigObjValidValues(fieldValue, config) {
    return _.find(config, function (each) {
      return each?.fieldValue == fieldValue;
    });
  }

  createMapForProperyName(mainData, map) {
    Object.keys(mainData)?.forEach(x => {
      if (mainData?.[x]?.propertyValue) {
        try {
          mainData[x]['parsedObjectData'] = JSON.parse(mainData[x]?.propertyValue);
          map.set(mainData[x]['clientId'], mainData[x]['parsedObjectData']);
        }
        catch (error) {
          map.set(x, null);
        }
      }
    })
  }

  getAttributeObject(map, clientId) {
    if (map.get(clientId)) {
      return map.get(clientId);
    }
    else {
      return map.get(Constants.BASE_CLIENTID);
    }

  }

  trimLeadingZeroes(empId) {
    if (empId)
      return empId?.replace(/^0+/, "");
    else
      return "NA"
  }

  /**
   * Method to check if 'skillName' is in the agentSkills array (case-insensitive) 
   * @param skillName 
   * @returns 
   */
  checkAgentSkill(skillName: any): boolean {
    return this.userData?.agentSkills?.some(skill => skill?.toLowerCase() === skillName);
  }

  getDate(date) {
    if (date) 
      return moment(date)?.format('MMM-DD-YYYY');
    else 
      return 'NA';
  }

  /**
   * Set authAttempt for live user //CCR3-6188
   */

   setAuthattempt(model) {
    let activeTabmodel = this.authAttempts.get(this.activeCustTab.customerSessionId);

    if (this.authAttempts.has(this.activeCustTab.customerSessionId)) {
      model["seq"] = (activeTabmodel.length+1)?.toString();
      activeTabmodel.push(model);
      this.authAttempts.set(this.activeCustTab.customerSessionId, activeTabmodel);
    } else {
      model["seq"] = '1';
      this.authAttempts.set(this.activeCustTab.customerSessionId, [model]);
    }

  }



  /**
   * Copyig this method from CSBusingess logic to here as it is common method to be used in mutiple services.
   * using it from CSBusingess service is creating build issue .So requesting all to use it 
   * instead of the one defined in customer-search-business-logic 
   * By- Pooja 
   * @param cpClientId 
   * @returns 
   */
  checkClientSystemMappingAndReplace(cpClientId) {
    for (const record of this.clientSystemIds) {
      if (record.data !== null) {
        for (const key in record.data) {
          if (record.data.hasOwnProperty(key)) {
            const dataItem = record.data[key];
            if (dataItem && dataItem?.systemName == Constants.CLIENT_SYSTEM_MAPPING_IH
              && dataItem?.targetSystemAttributeName == Constants.CLIENT_SYSTEM_MAPPING_CLIENT
              && dataItem?.clientId == cpClientId
            ) {
              return dataItem?.targetSystemAttributeValue;
            }
          }
        }
      }
    }
    return cpClientId;
  }


  /**
   * Below method created to fix CCR1-8363. This method return true if there is any
   * live SL1(unknown) call/chat. This method utilized in Customer Search component to disable and enable
   * Double click when live SL1 call/chat land on Care Portal.
   * @author - Sultan Khan
   */
  checkDuplicateCustomerSearchHavingLiveInteraction(): boolean {
    return this.customerTabs?.some(
      (tab) =>
        tab?.id == 1 &&
        tab?.conversationId &&
        tab?.CS_SECURITY_LEVEL == '0' &&
        (tab?.activeCall || tab?.activeChat)
    );
  }

  /**
   * 
   * In case of enterprise client, it will return platformInternalID based on systemInstanceId
   * CCR1-8079 
   * @author :Pooja Gupta
   * @param systemInstanceId 
   */

  getPIIbySystemInstaneId(systemInstanceId){
   const idMappingArr =  this.activeCustTab.tabData.tabData?.idMapping ;
   let idMapping =  idMappingArr?.find(x => x.systemInstanceId == systemInstanceId);
   if(idMapping){
      return idMapping?.platformInternalId; //Case of Enterpise client
   }
   else{
     return idMappingArr?.[0]?.platformInternalId; // Case of NonEnterprise client (Ex:premier)
   }

  }



  getPreferenceRegion() {
    let preferenceValue = sessionStorage.getItem('selectedRegion') ? sessionStorage.getItem('selectedRegion') : this.preferenceRegion;
    let isPrefrenceRegionObj = this.alisRegions?.find(x => x?.region == preferenceValue);
    if (isPrefrenceRegionObj) {
      this.prefrenceRegionObj = isPrefrenceRegionObj;
      let clientID = this.getObjFromConfigObj(isPrefrenceRegionObj?.region + Constants.ALIS_CLIENT_ID);

      if (clientID) {
        this.GENESYS_CLOUD_CLIENT_ID = clientID?.fieldValue;
        sessionStorage.setItem('ALIS_CLIENT_ID', clientID?.fieldValue);
      }
    } else {
      this.prefrenceRegionObj = null;
    }
  }

//Girish --CCR1-5174
  /**
    * Method to get primaryLanguage and preferredLocale
    * @author :Girish
    */

  getPrimaryLanguage(res) {
    const primaryLanguage = res?.primaryLanguage;
    let obj = _.find(this.primaryLanguage, (each) => each.fieldKey == primaryLanguage);
    if (obj) {
      return obj?.fieldValueDescription
    }
    else return '';
  }

  getPreferredLocale(res) {
    const preferredLocale = res?.preferredLocale;
    let obj = _.find(this.preferredLocale, (each) => each.fieldValue == preferredLocale);
    if (obj) {
      return obj?.fieldValueDescription
    }
    else return '';
  }


   /**
   * Increments the refresh counter and store the module name in moduleRefreshCounterMap each time the user clicks the refresh
   * CCR3-6969 
   * @author :HASHID
   * 
   */
  increAlisRefreshCounter(moduleName: string): void {
    const current = this.moduleRefreshCounterMap.get(moduleName) || 0;
    this.moduleRefreshCounterMap.set(moduleName, current + 1);
   
  }

    /**
   * Returns the current refresh count from each module and resets it to 0 for the next cycle.
   * CCR3-6969 
   * @author :HASHID
   * 
   */
  getAndResetRefreshCounters(): { [module: string]: number } {
    const result: { [module: string]: number } = {};
    this.moduleRefreshCounterMap.forEach((value, key) => {
      result[key] = value;
    });
    // Reset the counters
    this.moduleRefreshCounterMap.clear();
    return result;
  }

     /**
   * Returns the true/false if user intiated any refresh request baced on moduleRefreshCounterMap .
   * CCR3-6969 
   * @author :HASHID
   * 
   */
  hasAnyCounter(): boolean {
    return this.moduleRefreshCounterMap.size > 0;
  }
    /**
   * Sends the refresh count and module to the backend (SQS/DB) in string format for logging or analytics.
   * CCR3-6969 
   * @author :HASHID
   * 
   */
  alisIntractionRefreshTracToSqs(message: { [module: string]: number }) {
    const messageStr = Object.entries(message)
    .map(([key, value]) => `${key}: ${value}`)
    .join(' | ');
    this.captureAlisIntractToDb(messageStr, Constants.USAGE);
 }

/**
 * Retrieves the customer data from the `genesysCallObj` object.
 *
 * This method searches through the `participants` array in the `eventBody` of the `genesysCallObj`
 * to find the participant with a `purpose` of "customer" and returns their `attributes` if available.
 *
 * @returns {any} The `attributes` of the customer participant, or `undefined` if no matching participant is found.
 */
  getCustomerData() {
    return this.genesysCallObj?.eventBody?.participants.find(
      (x) =>
        x?.['purpose'] == 'customer' && x?.['attributes'])?.attributes;
  }

  /**
  * Triggers a log event by emitting a message and its source file name.
  *
  * @param message - The log message to be recorded.
  * @param fileName - Name of the file from where the log is triggered.
  *
  * Usage:
  * This method is useful for centralized logging by pushing structured log data 
  * into a logging observable (`logSubject`), which can be subscribed elsewhere 
  * for monitoring or debugging.
  */
  triggerLog(message: any, fileName: string, Type?: string) {
    this.logSubject.next({ message, fileName, Type });
  }

    /**
   * Opens a dialog to handle environment-related actions.
   *
   * @param type - A string indicating the type of environment issue or message to display.
   *
   * The dialog includes the following properties:
   * - `title`: An empty string, as no title is provided.
   * - `subheading`: An empty string, as no subheading is provided.
   * - `message`: The provided `type` parameter, which specifies the dialog's message.
   * - `firstbutton`: A constant representing the "Continue" button.
   * - `secondbutton`: A constant representing the "Do Not Register" button.
   * - `crossIcon`: A boolean indicating whether the cross icon is displayed (set to `false`).
   * - `comingFrom`: A string indicating the origin of the dialog (set to `'dashboard'`).
   * - `additionalClass`: A string specifying additional CSS classes for styling (set to `'end-register'`).
   *
   * Additionally, this method sets the `invalidENV` property of `rootScope` to `true`.
   * CCR3-10534
   */
    openEnvironmentDialog(Msg: string, secondMsg?: string) {
      this.invalidENV=true;
      if(this.dialog.getDialogById('environmentDialog')){
        return;
      }
      
      this.openDialog({
        title: Constants.ALIS_ORG_NAME_TITLE,
        subheading: '',
        message: Msg,
        secondMessage:secondMsg, 
        firstbutton: Constants.buttonEnum.doNotRegister,
        secondbutton: Constants.buttonEnum.continue,
        crossIcon: false,
        comingFrom: '',
        additionalClass: '',
        id: 'environmentDialog'
      });
    }



    /**
     * Formats the agent summary into a structured wrap-up text.
     * @param agentSummary - The agent summary object containing reason, resolution, followup, and text.
     * @returns A formatted string summarizing the agent's wrap-up.
     */


    formatAgentSummaryWrapUp(agentSummary: any): string {
      let summary: string[] = [];

      if (agentSummary?.reason?.description) {
        summary.push(`Reason for call:\n${agentSummary.reason.description}`);
      }
      if (agentSummary?.resolution?.description) {
        summary.push(`Resolution:\n${agentSummary.resolution.description}`);
      }
      if (agentSummary?.followup?.description) {
        summary.push(`Action items:\n${agentSummary.followup.description}`);
      }
      if (agentSummary?.text) {
        summary.push(`Details:\n${agentSummary.text}`);
      }

      return summary.join('\n\n').trim();
    }

     getClientSystemAttributeValue(cpClientId,systemName,attributeName){
   for (const record of this.clientSystemIds) {
      if (record.data !== null) {
        for (const key in record.data) {
          if (record.data.hasOwnProperty(key)) {
            const dataItem = record.data[key];
            if (dataItem && dataItem?.systemName == systemName
              && dataItem?.targetSystemAttributeName == attributeName
              && dataItem?.clientId == cpClientId
            ) {
              return dataItem?.targetSystemAttributeValue;
            }
          }
        }
      }
    }
    return null;
  }

  //@amarjeet added logic for CCR3-12547
  identifyUserSubjectType(clientId) {
    let identifyUser = this.clientPropDataMap?.get(clientId)?.find((x: any) => x?.propertyName == Constants.SAUTH_OVERRIDDEN_SUBJECTTYPE);
    let subjectType = identifyUser ? JSON.parse(identifyUser?.propertyValue)?.subjectType : null;
    if (subjectType == Constants.PRSN) {
      return true;
    } else {
      return false;
    }
  }

}
